<div class="custom-date-dialog">
  <h2 mat-dialog-title>{{ 'Custom Date Range' | translate: locale.language }}</h2>

  <mat-dialog-content class="date-dialog-content">
    <mat-form-field appearance="outline" class="date-range-field" style="width: 100%" [formGroup]="customDateForm">
      <mat-label>{{ 'Date Range' | translate: locale.language }}</mat-label>
      <mat-date-range-input [max]="today" [rangePicker]="picker">
        <input
          matStartDate
          formControlName="start"
          [placeholder]="'Filter.StartDate' | translate: locale.language"
          [attr.aria-label]="'Filter.StartDate' | translate: locale.language" />
        <input
          matEndDate
          formControlName="end"
          [placeholder]="'Filter.EndDate' | translate: locale.language"
          [attr.aria-label]="'Filter.EndDate' | translate: locale.language" />
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ 'Cancel' | translate: locale.language }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onApply()"
      [disabled]="!customDateForm.valid">
      {{ 'Apply' | translate: locale.language }}
    </button>
  </mat-dialog-actions>
</div>
